//Variables to replace
const poolId = 'ap-southeast-7_EyFCxXMJ5'
const clientId = '501rj67lmsd05igl0jchuuueb'
const api = 'https://x4oc5skxsa.execute-api.ap-southeast-7.amazonaws.com/Prod'

const Config = {
    UserPoolId: poolId,
    AppClientId: clientId,
    ApiURL: api + '/notes'
}

export default Config